/**
 * InfoPanel - Collapsible info/help section
 * @module wellRegistrationTotals/components/molecules/InfoPanel
 */

import React from "react";
import { Typography } from "@material-ui/core";
import InfoBox from "../../../../../../components/InfoBox";

/**
 * Collapsible info panel explaining the report
 */
const InfoPanel = React.memo(() => {
  return (
    <InfoBox title="How This Report Works">
      <Typography variant="subtitle2" gutterBottom style={{ marginTop: 8 }}>
        Well Registration Totals Table
      </Typography>
      <Typography variant="body2" color="textSecondary" component="div">
        <ul style={{ margin: "4px 0", paddingLeft: 20 }}>
          <li>
            <strong>2002–2025 Row:</strong> Cumulative baseline totals.
            Month-by-month detail is not available for these years.
          </li>
          <li>
            <strong>Monthly Rows:</strong> Registration counts for each month of
            the selected year. All 12 months are shown, even if totals are zero.
          </li>
          <li>
            <strong>Total Row:</strong> Sum of all months for the selected year.
          </li>
          <li>
            <strong>Total Registered:</strong> Baseline (2002–2025) plus all
            registrations from 2026 through your selected year.
          </li>
          <li>
            <strong>Drilldown:</strong> Click any month or Total row to view a
            map and table of wells registered during that period.
          </li>
        </ul>
      </Typography>

      <Typography variant="subtitle2" gutterBottom style={{ marginTop: 8 }}>
        Adjustments Table
      </Typography>
      <Typography variant="body2" color="textSecondary" component="div">
        <ul style={{ margin: "4px 0", paddingLeft: 20 }}>
          <li>
            <strong>**Never Drilled:</strong> Wells with "Never Drilled" status
            (2002–2025 historical totals + 2026 onward dynamic counts). N/A for
            grandfathered columns.
          </li>
          <li>
            <strong>**Plugged:</strong> Wells with "Plugged" status (2002–2025
            historical totals + 2026 onward dynamic counts).
          </li>
          <li>
            <strong>**Adjusted Total:</strong> Active wells after removing Never
            Drilled and Plugged.
          </li>
        </ul>
      </Typography>

      <Typography
        variant="body2"
        color="textSecondary"
        style={{ marginTop: 8 }}
      >
        <strong>Note:</strong> 2002–2025 data is historical aggregated totals
        (individual well breakdowns not available). 2026 onward uses individual
        well records.
      </Typography>
    </InfoBox>
  );
});

InfoPanel.displayName = "InfoPanel";

export default InfoPanel;
